// extracted by mini-css-extract-plugin
export default {"tag":"o9zvISA","tag--default":"qzafyg_","tag--disabled":"n8kovRe","tag--lime":"RYbUh78","tag__button":"HpbetKt","tag__icon":"qmnkJZ8"};